import { useState, useEffect } from "react";
import { Drawer, Form, Input, Select, Upload, Button, message } from "antd";
import { getFromLocalStorage, CONSTANT } from "../../Utils";

const { TextArea } = Input;
const { Option } = Select;

const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

export const ReportIssuePanel = ({ open, onClose, onSubmit }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [userInfo, setUserInfo] = useState();

    const getUser = () => {
        const user = getFromLocalStorage("user");
        setUserInfo(user);
    };

    useEffect(() => {
        if (open) {
            getUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const isSystemAdmin = userInfo?.user?.person_type_id === CONSTANT.SYSTEMADMIN;

    const handleFinish = async (values) => {
        try {
            setSubmitting(true);
            const fileList = values.attachments || [];
            const attachmentsBase64 = await Promise.all(
                fileList.map((item) =>
                    fileToBase64(item.originFileObj).then((base64) => ({
                        name: item.name,
                        base64,
                    }))
                )
            );
            const payload = { ...values, attachments: attachmentsBase64 };
            if (onSubmit) {
                await onSubmit("submitIssue", payload);
            }
            form.resetFields();
            onClose();
        } catch (err) {
            message.error(err?.message || "Failed to submit issue");
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Drawer
            title="Report an Issue"
            placement="right"
            width={420}
            onClose={handleClose}
            open={open}
            destroyOnClose
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={handleFinish}
                initialValues={{ priority: "Medium", repo: "visilant_webapp", attachments: [] }}
            >
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true, message: "Please enter a title" }]}
                >
                    <Input placeholder="Brief summary of the issue" />
                </Form.Item>

                <Form.Item label="Description" name="description">
                    <TextArea rows={4} placeholder="Describe the issue in detail" />
                </Form.Item>

                <Form.Item label="Priority" name="priority">
                    <Select>
                        <Option value="Low">Low</Option>
                        <Option value="Medium">Medium</Option>
                        <Option value="High">High</Option>
                        <Option value="Critical">Critical</Option>
                    </Select>
                </Form.Item>

                {isSystemAdmin && (
                    <Form.Item label="Application" name="repo">
                        <Select>
                            <Option value="visilant_webapp">Webapp</Option>
                            <Option value="visilant_api">API</Option>
                        </Select>
                    </Form.Item>
                )}

                <Form.Item label="Attachments" name="attachments" valuePropName="fileList" getValueFromEvent={(e) => e && e.fileList}>
                    <Upload.Dragger multiple beforeUpload={() => false}>
                        <p className="ant-upload-drag-icon">
                            <span role="img" aria-label="upload">📎</span>
                        </p>
                        <p className="ant-upload-text">Drop files here or click to browse</p>
                        <p className="ant-upload-hint">Images or videos, up to 25MB each (0/5)</p>
                    </Upload.Dragger>
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={submitting}
                    >
                        Submit Issue
                    </Button>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

